import {
  SYNTHESIS_DECLINED,
  SYNTHESIS_FAILED,
  SYNTHESIS_PENDING,
  SYNTHESIS_RETRY_FAILED,
  TRY_AGAIN_LABEL,
} from '../studies/brief-copy.ts';
import type { BriefSynthesisRead } from './use-brief-synthesis.ts';

/**
 * Where writing the Brief has got to, on the Analyzing step while the study is being analysed.
 *
 * Drawn from the Brief read the shell holds (`useBriefSynthesis`), the same read the panel's
 * headline over this line is decided from, so the two are always about the same request; the
 * study read on the same beat is what moves the step on once the Brief is published.
 *
 * Nothing shows before the first read lands or while the study has no request: the panel's own
 * headline covers that wait.
 */
export const BriefSynthesisStatus = ({ brief }: { brief: BriefSynthesisRead }) => {
  const { synthesis, busy, retryFailed, retry } = brief;

  if (synthesis === null || synthesis.status === 'published') {
    return null;
  }

  if (synthesis.status === 'declined') {
    return <p data-test-id="launch-brief-status">{SYNTHESIS_DECLINED}</p>;
  }

  /*
    Decided on `retryable` before the status: a request still `pending` whose job the queue no
    longer holds will never be answered on its own, so it reads as the failure it is, with Try
    again, rather than as a Brief being written.
  */
  if (synthesis.status === 'pending' && !synthesis.retryable) {
    return <p data-test-id="launch-brief-status">{SYNTHESIS_PENDING}</p>;
  }

  return (
    <div className="launch-brief-failed">
      <p className="chat-error" data-test-id="launch-brief-status" role="alert">
        {SYNTHESIS_FAILED}
      </p>
      {synthesis.retryable && (
        <button
          type="button"
          data-test-id="launch-brief-retry"
          disabled={busy}
          onClick={() => void retry()}
        >
          {TRY_AGAIN_LABEL}
        </button>
      )}
      {retryFailed && (
        <p className="chat-error" data-test-id="launch-brief-retry-failed" role="alert">
          {SYNTHESIS_RETRY_FAILED}
        </p>
      )}
    </div>
  );
};
